import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../contexts/SettingsContext";
import { Mail, Phone, MapPin } from "lucide-react";
import { NewsletterSignup } from "./NewsletterSignup";

export default function Footer() {
    const { settings } = useSettings();
    return (
        <footer className="bg-stone-900 text-stone-200 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
                <div className="col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                        {settings.logo_url ? (
                            <img src={settings.logo_url} alt={settings.brand_name} className="w-9 h-9 object-contain" />
                        ) : (
                            <span className="w-9 h-9 grid place-items-center bg-sky-700 text-stone-50 font-serif text-lg">{(settings.brand_name || "H").charAt(0)}</span>
                        )}
                        <div>
                            <div className="font-serif text-2xl">{settings.brand_name}</div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-stone-400">{settings.brand_subtitle_full || settings.brand_subtitle}</div>
                        </div>
                    </div>
                    <p className="text-sm text-stone-400 max-w-md leading-relaxed">{settings.site_tagline}</p>
                </div>
                <div>
                    <div className="label-eyebrow text-stone-400 mb-4">Shop</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/shop" className="hover:text-sky-400">All medicines</Link></li>
                        <li><Link to="/ai-doctor" className="hover:text-sky-400">AI Doctor</Link></li>
                        <li><Link to="/doctors" className="hover:text-sky-400">Find a Doctor</Link></li>
                        <li><Link to="/blog" className="hover:text-sky-400" data-testid="footer-blog">Hahnemann Journal</Link></li>
                        <li><Link to="/enroll-doctor" className="hover:text-sky-400">Enroll as Doctor</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-eyebrow text-stone-400 mb-4">Contact</div>
                    <ul className="space-y-2 text-sm text-stone-300">
                        <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5" />{settings.contact_email}</li>
                        {settings.show_contact_phone !== false && settings.contact_phone && (
                            <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5" />{settings.contact_phone}</li>
                        )}
                        <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5" />India</li>
                    </ul>
                </div>
                <div>
                    <div className="label-eyebrow text-stone-400 mb-4">Legal</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/terms" className="hover:text-sky-400" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
                        <li><Link to="/privacy" className="hover:text-sky-400" data-testid="footer-privacy">Privacy Policy</Link></li>
                        <li><Link to="/refunds" className="hover:text-sky-400" data-testid="footer-refunds">Refund &amp; Cancellation</Link></li>
                        <li><Link to="/shipping" className="hover:text-sky-400" data-testid="footer-shipping">Shipping Policy</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-stone-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid md:grid-cols-2 gap-8 items-start">
                    <NewsletterSignup />
                </div>
            </div>
            <div className="border-t border-stone-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between text-xs text-stone-500">
                    <span>© {new Date().getFullYear()} {settings.brand_name} {settings.brand_subtitle_full || settings.brand_subtitle}</span>
                    <span className="mt-2 sm:mt-0">Disclaimer: AI suggestions are not a substitute for medical advice.</span>
                </div>
            </div>
        </footer>
    );
}
